var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{attrs:{"cols":"4","lg":"2"}},[_c('v-subheader',[_vm._v(_vm._s(_vm.label))])],1),_c('v-col',{attrs:{"cols":"8","lg":"3"}},[_c('v-text-field',{attrs:{"value":_vm.value,"readonly":""}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }